// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"110":"a9d99de6","474":"3fbe9ef9","859":"32701f3b"}[chunkId] + ".chunk.js";
};